import { useState } from 'react';
import { useRevalidator } from 'react-router';
import { Button } from '@/components/ui/button';
import { api, errMsg } from '@/lib/api';

export function FlowActions({ flow }: { flow: { id: string; status: string } }) {
  const { revalidate } = useRevalidator();
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);
  const [enrolEmail, setEnrolEmail] = useState('');

  async function setStatus(status: string) {
    setBusy(true);
    setMsg(null);
    try {
      await api(`/flows/${flow.id}/status`, { method: 'POST', json: { status } });
      revalidate();
    } catch (err) {
      setMsg(errMsg(err, 'Failed'));
    } finally {
      setBusy(false);
    }
  }

  async function enrol() {
    setBusy(true);
    setMsg(null);
    try {
      const list = await api<{ items: Array<{ id: string }> }>(`/contacts?q=${encodeURIComponent(enrolEmail)}&pageSize=1`);
      const contact = list.items[0];
      if (!contact) throw new Error('No contact with that email');
      const r = await api<{ skipped?: boolean; reason?: string }>(`/flows/${flow.id}/enrol`, { method: 'POST', json: { contactId: contact.id } });
      setMsg(r.skipped ? `Not enrolled: ${r.reason}` : 'Enrolled — the first step ran');
      revalidate();
    } catch (err) {
      setMsg(errMsg(err, 'Failed'));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex flex-wrap items-center gap-2 text-sm">
      {flow.status !== 'active' && flow.status !== 'archived' && (
        <Button size="sm" onClick={() => setStatus('active')} disabled={busy}>
          {flow.status === 'paused' ? 'Resume' : 'Activate'}
        </Button>
      )}
      {flow.status === 'active' && (
        <Button size="sm" variant="outline" onClick={() => setStatus('paused')} disabled={busy}>
          Pause
        </Button>
      )}
      {flow.status !== 'archived' && (
        <Button size="sm" variant="outline" onClick={() => { if (confirm('Archive this flow? Active runs will exit.')) setStatus('archived'); }} disabled={busy}>
          Archive
        </Button>
      )}
      {flow.status === 'active' && (
        <span className="flex items-center gap-1">
          <input value={enrolEmail} onChange={(e) => setEnrolEmail(e.target.value)} placeholder="enrol by email (test)" className="h-9 w-52 rounded-md border px-2" />
          <Button size="sm" variant="outline" onClick={enrol} disabled={busy || !enrolEmail}>
            Enrol
          </Button>
        </span>
      )}
      {msg && <span className="text-xs text-muted-foreground">{msg}</span>}
    </div>
  );
}
